import { Flex, theme, Typography } from "antd";
import BankLogo from "src/components/bankLogo";
import { getShebaBankName } from "src/utils/digits";

interface ShebaDisplayProps {
  sheba: string | null;
}

function ShebaDisplay({ sheba }: ShebaDisplayProps) {
  const { token } = theme.useToken();
  const bankName = sheba ? getShebaBankName(sheba) : null;

  return (
    <Flex
      align="center"
      gap={12}
      style={{
        width: "100%",
        minHeight: 40,
        padding: "6px 11px",
        borderRadius: 6,
        border: `1px solid ${token.colorBorder}`,
        backgroundColor: token.colorBgContainer,
      }}
    >
      {sheba && (
        <>
          {bankName && (
            <BankLogo name={bankName} size="sm" className="flex-shrink-0" />
          )}
          <Typography.Text
            style={{
              fontFamily: "monospace",
              fontSize: 15,
              direction: "ltr",
              letterSpacing: "0.02em",
            }}
          >
            {sheba}
          </Typography.Text>
        </>
      )}
    </Flex>
  );
}

export default ShebaDisplay;
